<!-- 
	AccountActions
	role: Public -- requires email link to not error
	Triggers firebase actions to allow user to verify email or reset password based off email link ?action=
-->

<template>
	<div class="account-actions text-white">
		<div v-if="loading">
			<div class="text-xl pb-4">Please wait...</div>
			<Loading />
		</div>
		<div v-else>
			<div v-if="action === 'verifyEmail'">
				<ActionEmailVerification v-bind:actionCode="actionCode" />
			</div>
			<div v-if="action === 'resetPassword'">
				<ActionResetPassword v-bind:actionCode="actionCode" />
			</div>
		</div>
	</div>
</template>

<script>
	import { useRoute } from "vue-router";

	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";
	import ActionEmailVerification from "@/components/ActionEmailVerification";
	import ActionResetPassword from "@/components/ActionResetPassword";

	export default {
		name: "AccountActions",
		components: {
			CustomButton,
			Loading,
			ActionEmailVerification,
			ActionResetPassword,
		},
		data() {
			return {
				loading: true,
				action: null,
				actionCode: null,
			};
		},
		created() {
			// process action
			const route = useRoute();

			window.addEventListener(
				"load",
				() => {
					const mode = route.query.mode;
					const actionCode = route.query.oobCode;

					this.action = mode;
					this.actionCode = actionCode;

					switch (mode) {
						case "verifyEmail":
							this.loading = false;
							break;
						case "resetPassword":
							this.loading = false;
							break;
						default:
							console.log("error");
							break;
					}
				},
				false
			);
		},
	};
</script>
